module.exports = __webpack_public_path__ + "static/media/Audit_Report_Letter_2020.2a6cd88f.pdf";